import { hc } from "hono/client";
import type { ApiComercial } from "../worker/api";

const LLAVE_DEV_PERSONA = "comercial.devPersona";

/** Solo local: correo con el que la API actúa (encabezado x-dev-persona). */
export function devPersona(): string | null {
  try {
    return localStorage.getItem(LLAVE_DEV_PERSONA);
  } catch {
    return null;
  }
}

export function fijarDevPersona(correo: string | null) {
  try {
    if (correo) localStorage.setItem(LLAVE_DEV_PERSONA, correo);
    else localStorage.removeItem(LLAVE_DEV_PERSONA);
  } catch {
    /* sin almacenamiento */
  }
}

/** Cliente RPC tipado punta a punta. `token()` devuelve el JWT de Supabase o null. */
export function crearApi(token: () => Promise<string | null>) {
  return hc<ApiComercial>("/", {
    headers: async () => {
      const t = await token();
      const h: Record<string, string> = {};
      if (t) h.authorization = `Bearer ${t}`;
      const dev = devPersona();
      if (!t && dev) h["x-dev-persona"] = dev;
      return h;
    },
  });
}

export type Api = ReturnType<typeof crearApi>;

export class ErrorApi extends Error {
  status: number;
  cuerpo: unknown;
  constructor(mensaje: string, status: number, cuerpo: unknown) {
    super(mensaje);
    this.name = "ErrorApi";
    this.status = status;
    this.cuerpo = cuerpo;
  }
}

/** Convierte una respuesta de Hono en datos o lanza ErrorApi con el mensaje del servidor. */
export async function leer<T>(r: Response): Promise<T> {
  if (!r.ok) {
    let mensaje = `Error ${r.status}`;
    let cuerpo: unknown = null;
    try {
      cuerpo = await r.json();
      mensaje = (cuerpo as { error?: string }).error ?? mensaje;
    } catch {
      /* sin cuerpo */
    }
    throw new ErrorApi(mensaje, r.status, cuerpo);
  }
  return (await r.json()) as T;
}
